import { useTranslation } from 'react-i18next'
import { EntityPageHeader } from '@/shared/components'
import { ActionList } from '../components'

export function ActionsListPage() {
  const { t } = useTranslation()

  return (
    <div>
      <EntityPageHeader
        title={t('administration.sections.actions.pageTitle', 'Gestion des Actions')}
        backTo="/administration"
        createTo="/administration/actions/create"
        createLabel={t('administration.sections.actions.createButton', 'Créer une action')}
      />
      <ActionList />
    </div>
  )
}
